module.exports = __webpack_public_path__ + "img/pet_daschund.4f846b49.svg";